// extracted by mini-css-extract-plugin
module.exports = {"header":"PurchaseOrderShowContainer_header__3Ao0N"};